export default __webpack_public_path__ + "static/media/Group9169.65259ece.svg";